import React from 'react';
import { Badge, Box, IconButton } from '@chakra-ui/react';

const TONE_STYLES = {
	default: {
		color: 'gray.600',
		bg: 'transparent',
		_hover: { bg: 'white', color: 'teal.600', boxShadow: 'sm' },
		_active: { bg: 'white' },
	},
	alert: {
		color: 'orange.600',
		bg: 'orange.50',
		_hover: { bg: 'orange.100', color: 'orange.700' },
		_active: { bg: 'orange.100' },
	},
	primary: {
		color: 'white',
		bg: 'teal.500',
		_hover: { bg: 'teal.600', transform: 'translateY(-1px)' },
		_active: { bg: 'teal.700' },
	},
};

export const HeaderToolbarBadge = ({ children, ...props }) => (
	<Badge
		colorScheme='red'
		variant='solid'
		borderRadius='full'
		position='absolute'
		top='-2px'
		right='-2px'
		px={1.5}
		minW='18px'
		h='18px'
		display='flex'
		alignItems='center'
		justifyContent='center'
		fontSize='10px'
		fontWeight='bold'
		lineHeight='1'
		border='2px solid white'
		boxShadow='sm'
		{...props}>
		{children}
	</Badge>
);

const HeaderToolbarIconButton = React.forwardRef(
	({ icon, 'aria-label': ariaLabel, tone = 'default', badge, size = 'sm', ...props }, ref) => (
		<Box position='relative' display='inline-flex' flexShrink={0}>
			<IconButton
				ref={ref}
				aria-label={ariaLabel}
				icon={icon}
				size={size}
				variant='ghost'
				borderRadius='lg'
				transition='all 0.2s ease'
				{...TONE_STYLES[tone]}
				{...props}
			/>
			{badge}
		</Box>
	),
);

HeaderToolbarIconButton.displayName = 'HeaderToolbarIconButton';

export default HeaderToolbarIconButton;
